// OdQueryParam will only have 4 query params : Filter, Sort, PageSize, and continuation token
export enum OdQueryParam {
    Filter = "filter",
    Sort = "sort",
    PageSize = "PageSize",
}